import { z } from 'zod'

/**
 * Admin password change form schema (DEC-ADMIN-010).
 *
 * - `current_password`: kötelező (a backend Hash::check-eli; rossz =>
 *   422 invalid current_password)
 * - `new_password`: min 12 karakter (Password::min(12)->letters->numbers,
 *   a backend további szigorúbb szabályokat is alkalmaz — 422 esetén a
 *   field-error-mapping mutatja az üzenetet)
 * - `new_password_confirmation`: client-side `refine` egyezést követel
 *   (a backend `confirmed` szabálya is ezt ellenőrzi)
 */
export const passwordChangeSchema = z
  .object({
    current_password: z.string().min(1, 'A jelenlegi jelszó kötelező'),
    new_password: z.string().min(12, 'Az új jelszó legalább 12 karakter legyen'),
    new_password_confirmation: z.string(),
  })
  .refine((data) => data.new_password === data.new_password_confirmation, {
    message: 'A két új jelszó nem egyezik',
    path: ['new_password_confirmation'],
  })

export type PasswordChangeFormValues = z.infer<typeof passwordChangeSchema>
